import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function SplitHeaderDuoTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-relaxed overflow-hidden" data-testid="resume-live-preview">
      <div className="flex">
        <div className="w-1/2 p-5" style={{ backgroundColor: "#0f172a" }}>
          <h1 className="text-white text-xl font-bold">{draft.full_name || "Your Name"}</h1>
          {draft.target_role && <p className="text-white/70 text-[12px] mt-1">{draft.target_role}</p>}
        </div>
        <div className="w-1/2 p-5 flex flex-col justify-center gap-1" style={{ backgroundColor: accent }}>
          {[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).map((line) => <p key={line} className="text-white text-[11px]">{line}</p>)}
        </div>
      </div>
      <div className="p-6">
        {draft.summary && <p className="text-slate-700 mb-4">{draft.summary}</p>}
        {draft.experience.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mb-2.5">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
          </div>
        )}
        {draft.skills.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Skills</h2>
            <p className="text-slate-700">{draft.skills.join(", ")}</p>
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
